import React, { useState, useEffect } from 'react';
import { ReactComponent as ArrowBottomIcon } from '@repo/common/assets/icons/24px/icon_24px_arrow-bottom.svg';

const FaqAccordion = ({ question, answer, isForceOpen = false }) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isForceOpen) {
      setIsOpen(true);
    }
  }, [isForceOpen]);

  return (
    <div className='w-full bg-transparent'>
      {/* Header */}
      <div
        className='flex justify-between items-center px-[18px] py-[26px] cursor-pointer'
        onClick={() => setIsOpen((prev) => !prev)}
      >
        <span className='text-text-primary typo-b16Strong'>{question}</span>
        <div className='w-6 h-6 flex items-center justify-center flex-shrink-0'>
          <ArrowBottomIcon
            className={`color-icon-primary transition-transform duration-300 ease ${
              isOpen ? 'rotate-180' : 'rotate-0'
            }`}
          />
        </div>
      </div>

      {/* Content */}
      <div
        className={`grid transition-[grid-template-rows] duration-300 ease-in-out ${
          isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
        }`}
      >
        <div className='overflow-hidden'>
          <div className='flex items-start gap-2.5 bg-grayscale-gray02/60 pl-[38px] pr-[18px] pt-[30px] pb-[40px]'>
            <p className='typo-b14 text-text-tertiary whitespace-pre-line text-left'>
              {answer}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FaqAccordion;
